const CHECKOUT_DRAFT_KEY = 'grand78_checkout_v1';
export function readCommentDraft() {
    try {
        const raw = sessionStorage.getItem(CHECKOUT_DRAFT_KEY);
        if (!raw)
            return '';
        const d = JSON.parse(raw);
        return typeof d.comment === 'string' ? d.comment : '';
    }
    catch {
        return '';
    }
}
export function writeCommentDraft(comment) {
    try {
        sessionStorage.setItem(CHECKOUT_DRAFT_KEY, JSON.stringify({ comment }));
    }
    catch {
        /* ignore */
    }
}
export function clearCommentDraft() {
    try {
        sessionStorage.removeItem(CHECKOUT_DRAFT_KEY);
    }
    catch {
        /* ignore */
    }
}
